export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  chapters: ComicChapter[];
}

export const comics: Comic[] = [
  {
    id: '1',
    title: '霸道总裁的契约新娘',
    author: '星辰大海',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20manhwa%20cover%20art%2C%20beautiful%20woman%20in%20elegant%20dress%2C%20rich%20CEO%20male%20lead%2C%20dramatic%20lighting%2C%20soft%20pastel%20colors%2C%20clean%20simple%20background%2C%20romantic%20atmosphere%2C%20modern%20fashion%20illustration%20style%2C%20high%20quality%20digital%20art&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '她是一个普通女孩，却在一场意外中与霸道总裁签订了契约婚姻。本以为只是一场交易，却没想到他渐渐对她动了真心。当契约到期，她是选择离开还是留下？一场跨越阶层的浪漫爱情故事即将展开。',
    category: '韩漫',
    categorySlug: 'hanman',
    tags: ['爱情', '都市', '契约婚姻', '霸道总裁'],
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    favorites: 89000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: '1-1', title: '第1话 意外的相遇', number: 1, updatedAt: '2026-06-01' },
      { id: '1-2', title: '第2话 契约签订', number: 2, updatedAt: '2026-06-08' },
      { id: '1-3', title: '第3话 同居生活开始', number: 3, updatedAt: '2026-06-15' },
      { id: '1-4', title: '第4话 心动时刻', number: 4, updatedAt: '2026-06-22' },
      { id: '1-5', title: '第5话 前任出现', number: 5, updatedAt: '2026-06-29' },
      { id: '1-6', title: '第6话 危机降临', number: 6, updatedAt: '2026-07-06' },
      { id: '1-7', title: '第7话 他的温柔', number: 7, updatedAt: '2026-07-13' },
      { id: '1-8', title: '第8话 心意相通', number: 8, updatedAt: '2026-07-20' },
      { id: '1-9', title: '第9话 突来的告白', number: 9, updatedAt: '2026-07-27' },
      { id: '1-10', title: '第10话 幸福的选择', number: 10, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '2',
    title: '重生之都市修仙',
    author: '天蚕土豆豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20cover%20art%2C%20young%20male%20cultivator%20with%20flowing%20robes%2C%20glowing%20energy%20effects%2C%20ancient%20Chinese%20and%20modern%20city%20fusion%2C%20dramatic%20composition%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '一代仙帝渡劫失败，重生回到高中时代。带着前世记忆，他要在都市中重新修炼，弥补前世遗憾，保护所爱之人。且看仙帝如何在现代都市中搅动风云，再登巅峰！',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['修仙', '重生', '都市', '热血'],
    status: '连载中',
    rating: 9.5,
    views: 2560000,
    favorites: 156000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: '2-1', title: '第1话 渡劫失败', number: 1, updatedAt: '2026-05-15' },
      { id: '2-2', title: '第2话 重回高中', number: 2, updatedAt: '2026-05-22' },
      { id: '2-3', title: '第3话 修炼开始', number: 3, updatedAt: '2026-05-29' },
      { id: '2-4', title: '第4话 校园风波', number: 4, updatedAt: '2026-06-05' },
      { id: '2-5', title: '第5话 初露锋芒', number: 5, updatedAt: '2026-06-12' },
      { id: '2-6', title: '第6话 暗流涌动', number: 6, updatedAt: '2026-06-19' },
      { id: '2-7', title: '第7话 突破筑基', number: 7, updatedAt: '2026-06-26' },
      { id: '2-8', title: '第8话 家族来人', number: 8, updatedAt: '2026-07-03' },
    ],
  },
  {
    id: '3',
    title: '秘密花园',
    author: '樱花漫语',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20slice%20of%20life%20cover%20art%2C%20young%20girl%20in%20school%20uniform%20in%20beautiful%20flower%20garden%2C%20soft%20watercolor%20style%2C%20warm%20sunlight%2C%20cherry%20blossoms%2C%20gentle%20pastel%20color%20palette%2C%20clean%20simple%20backdrop%2C%20emotional%20and%20nostalgic%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '内向的高中女生小樱，在校园角落发现了一个被遗忘的花园。在那里，她遇到了同样孤独的园艺社学长。两人一起照料花园，也在彼此心中种下了秘密的情愫。这是一个关于青春、成长和秘密的温暖故事。',
    category: '日漫',
    categorySlug: 'riman',
    tags: ['校园', '青春', '治愈', '恋爱'],
    status: '已完结',
    rating: 9.7,
    views: 1890000,
    favorites: 201000,
    updatedAt: '2026-07-20',
    chapters: [
      { id: '3-1', title: '第1话 被遗忘的花园', number: 1, updatedAt: '2025-12-01' },
      { id: '3-2', title: '第2话 园艺社的学长', number: 2, updatedAt: '2025-12-15' },
      { id: '3-3', title: '第3话 第一颗种子', number: 3, updatedAt: '2026-01-01' },
      { id: '3-4', title: '第4话 雨天的约定', number: 4, updatedAt: '2026-01-15' },
      { id: '3-5', title: '第5话 花开时节', number: 5, updatedAt: '2026-02-01' },
      { id: '3-6', title: '最终话 秘密花园', number: 6, updatedAt: '2026-02-15' },
    ],
  },
  {
    id: '4',
    title: '暗夜猎魔人',
    author: '黑夜行者',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20cover%2C%20male%20hunter%20with%20dark%20coat%20and%20sword%2C%20demonic%20creatures%20in%20background%2C%20dark%20moody%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20dramatic%20lighting%20from%20above%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '在这个世界上，存在着普通人看不见的「暗夜生物」。猎魔人是专门猎杀这些怪物的职业。失去家人的少年林夜，在一位神秘猎魔人的指引下踏上复仇之路。黑暗中的猎杀，即将开始！',
    category: '韩漫',
    categorySlug: 'hanman',
    tags: ['动作', '奇幻', '复仇', '热血'],
    status: '连载中',
    rating: 9.0,
    views: 980000,
    favorites: 72000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: '4-1', title: '第1话 那个夜晚', number: 1, updatedAt: '2026-04-01' },
      { id: '4-2', title: '第2话 猎魔人出现', number: 2, updatedAt: '2026-04-08' },
      { id: '4-3', title: '第3话 训练开始', number: 3, updatedAt: '2026-04-15' },
      { id: '4-4', title: '第4话 首次任务', number: 4, updatedAt: '2026-04-22' },
    ],
  },
  {
    id: '5',
    title: '穿越之王妃不好惹',
    author: '月下独酌',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20romance%20cover%2C%20beautiful%20ancient%20Chinese%20princess%20in%20red%20hanfu%20dress%2C%20palace%20background%2C%20golden%20accents%2C%20elegant%20traditional%20Chinese%20art%20style%2C%20warm%20candlelight%20atmosphere%2C%20clean%20simple%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '现代女医生苏晚晴意外穿越到大燕王朝，成为不受宠的五王妃。面对宫廷阴谋和各方势力的暗算，她凭借现代医学知识和高超智慧，在危机四伏的皇宫中步步为营，走出属于自己的精彩人生。',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['穿越', '古风', '宫斗', '女强'],
    status: '连载中',
    rating: 9.3,
    views: 2150000,
    favorites: 134000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: '5-1', title: '第1话 意外穿越', number: 1, updatedAt: '2026-05-01' },
      { id: '5-2', title: '第2话 五王府', number: 2, updatedAt: '2026-05-08' },
      { id: '5-3', title: '第3话 初见王爷', number: 3, updatedAt: '2026-05-15' },
      { id: '5-4', title: '第4话 宫宴风波', number: 4, updatedAt: '2026-05-22' },
      { id: '5-5', title: '第5话 妙手仁心', number: 5, updatedAt: '2026-05-29' },
      { id: '5-6', title: '第6话 暗箭难防', number: 6, updatedAt: '2026-06-05' },
    ],
  },
  {
    id: '6',
    title: '邻座的怪同学',
    author: '青山小雨',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20school%20comedy%20cover%2C%20quirky%20male%20student%20and%20serious%20female%20student%20sitting%20at%20desks%2C%20chalkboard%20background%2C%20bright%20cheerful%20colors%2C%20fun%20and%20lively%20atmosphere%2C%20clean%20simple%20illustration%20style%2C%20warm%20classroom%20lighting&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '学霸少女林小希的同桌是一个从不来上学的怪人。某天，这个怪人突然出现在教室里，从此她的平静生活被彻底打乱。一个不苟言笑的学霸和一个天马行空的怪人，会发生怎样有趣的故事？',
    category: '日漫',
    categorySlug: 'riman',
    tags: ['校园', '搞笑', '恋爱', '青春'],
    status: '已完结',
    rating: 9.4,
    views: 1450000,
    favorites: 118000,
    updatedAt: '2026-06-30',
    chapters: [
      { id: '6-1', title: '第1话 怪人出现', number: 1, updatedAt: '2025-10-01' },
      { id: '6-2', title: '第2话 被迫同桌', number: 2, updatedAt: '2025-10-15' },
      { id: '6-3', title: '第3话 午休大作战', number: 3, updatedAt: '2025-11-01' },
      { id: '6-4', title: '第4话 学园祭', number: 4, updatedAt: '2025-11-15' },
      { id: '6-5', title: '最终话 毕业那天', number: 5, updatedAt: '2025-12-01' },
    ],
  },
  {
    id: '7',
    title: '我的ID是江南美人',
    author: '韩国漫画家协会',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20college%20romance%20cover%2C%20beautiful%20female%20lead%20with%20long%20hair%20on%20university%20campus%2C%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20tones%2C%20clean%20minimal%20background%2C%20romantic%20and%20fresh%20digital%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '因为外貌而自卑的女孩姜美莱，在整容后以全新面貌进入大学。然而在校园里，她遇到了知道她过去的中学同学都景硕。外表变美了，但内心是否也能变得强大？一部关于成长、自信和真爱的故事。',
    category: '韩漫',
    categorySlug: 'hanman',
    tags: ['校园', '爱情', '成长', '整容'],
    status: '已完结',
    rating: 9.6,
    views: 3100000,
    favorites: 245000,
    updatedAt: '2026-07-15',
    chapters: [
      { id: '7-1', title: '第1话 新的开始', number: 1, updatedAt: '2025-08-01' },
      { id: '7-2', title: '第2话 大学第一天', number: 2, updatedAt: '2025-08-08' },
      { id: '7-3', title: '第3话 重逢', number: 3, updatedAt: '2025-08-15' },
      { id: '7-4', title: '第4话 过去的阴影', number: 4, updatedAt: '2025-08-22' },
      { id: '7-5', title: '第5话 真心话', number: 5, updatedAt: '2025-09-01' },
      { id: '7-6', title: '最终话 美丽的你', number: 6, updatedAt: '2025-09-15' },
    ],
  },
  {
    id: '8',
    title: '全职高手之巅峰荣耀',
    author: '蝴蝶兰',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20gaming%20cover%2C%20cool%20male%20gamer%20with%20headset%2C%20cyberpunk%20gaming%20arena%20background%2C%20neon%20lights%2C%20competitive%20atmosphere%2C%20dynamic%20action%20pose%2C%20golden%20and%20teal%20accent%20colors%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '电竞传奇叶修被俱乐部驱逐后，在一家网吧重新开始。他组建新战队，带领一群草根选手从零开始冲击职业联赛冠军。这不仅是一部电竞题材的漫画，更是关于梦想、友情和永不放弃的热血故事。',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['电竞', '热血', '竞技', '友情'],
    status: '连载中',
    rating: 9.8,
    views: 5200000,
    favorites: 389000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: '8-1', title: '第1话 被驱逐的大神', number: 1, updatedAt: '2026-03-01' },
      { id: '8-2', title: '第2话 网吧奇遇', number: 2, updatedAt: '2026-03-08' },
      { id: '8-3', title: '第3话 新队友', number: 3, updatedAt: '2026-03-15' },
      { id: '8-4', title: '第4话 首战告捷', number: 4, updatedAt: '2026-03-22' },
      { id: '8-5', title: '第5话 团队磨合', number: 5, updatedAt: '2026-03-29' },
      { id: '8-6', title: '第6话 强敌来临', number: 6, updatedAt: '2026-04-05' },
    ],
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '韩漫', slug: 'hanman' },
  { name: '日漫', slug: 'riman' },
  { name: '国漫', slug: 'guoman' },
  { name: '下拉式漫画', slug: 'scroll' },
];

export const featuredComicIds = ['2', '8', '7', '1'];
export const latestUpdateIds = ['5', '1', '8', '4', '2', '3'];